// extracted by css-extract-rspack-plugin
export default {"button":"subtitles-styles-button-c81d56f4","buttonContainer":"subtitles-styles-buttonContainer-5a88008c"};